import React from 'react';
import cx from 'classnames';
import { oneOf } from 'prop-types';

const CLASS_ROOT = 'page-section';

const propTypes = {
  type: oneOf(['coffee', 'creme', 'beige', 'transparent', 'none']),
  space: oneOf(['small', 'large', 'none']),
};

const PageSection = ({ className, children, type, space, ...other }) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--${type}`]: type,
      [`${CLASS_ROOT}--${space}`]: space,
    },
    className,
  );

  return (
    <section className={classes} {...other}>
      {children}
    </section>
  );
};

PageSection.propTypes = propTypes;

export default PageSection;
